import { stringify } from "query-string";

let prefixUrl = "";

const query = (method, endpoint, parameters, token, isUpload = false) => {
  let url = `${prefixUrl}${endpoint}`;
  if (method === "get") {
    const queryString = stringify(parameters);
    url = `${prefixUrl}${endpoint}?${queryString}`;
  }
  const header = new Headers();
  if (token) {
    header.set("Authorization", `Token ${token}`);
  }

  if (!isUpload) {
    header.set("Content-Type", "application/json");
  }
  return fetch(url, {
    method: method,
    headers: header,
    body:
      method === "get"
        ? null
        : isUpload
        ? parameters
        : JSON.stringify(parameters),
  })
    .then((response) => {
      switch (response.status) {
        case 500:
          throw new Error("系统错误", 500);
        case 401:
          throw new Error("身份认证信息未提供，请重新登录。");
        case 404:
          throw new Error("访问路径未找到，请重试。");
        case 403:
          throw new Error("访问未授权，请联系管理。");
        case 405:
          throw new Error("访问未授权，请联系管理。");
        default: {
          const contentType = response.headers.get("content-type") || "";
          if (contentType.includes("application/json")) {
            return response.json();
          } else {
            return response.blob();
          }
        }
      }
    })
    .catch((error) => {
      return Promise.reject(error);
    });
};

export const get = (endpoint, parameters, token) => {
  return query("get", endpoint, parameters, token);
};

export const post = (endpoint, parameters, token) => {
  return query("post", endpoint, parameters, token);
};

export const patch = (endpoint, parameters, token) => {
  return query("PATCH", endpoint, parameters, token);
};

export const put = (endpoint, parameters, token) => {
  return query("put", endpoint, parameters, token);
};

export const remove = (endpoint, parameters, token) => {
  return query("delete", endpoint, parameters, token);
};

export const upload = (endpoint, parameters, token) => {
  return query("post", endpoint, parameters, token, true);
};

export const getUploadURL = (url) => {
  return prefixUrl + url;
};
